/* Solvira · diseño v3. Comportamientos ligeros; se carga con defer. */
(function () {
  if (window.__drV3) return;
  window.__drV3 = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io = 'IntersectionObserver' in window;

  /* Barras de progreso de los carriles */
  function initRails(root) {
    (root || document).querySelectorAll('.v3-rail').forEach(function (rail) {
      if (rail.__v3) return;
      rail.__v3 = true;
      var track = rail.querySelector('.v3-rail-track');
      var bar = rail.querySelector('.v3-rail-bar');
      if (!track || !bar) return;
      var thumb = bar.querySelector('i');
      var ticking = false;
      function update() {
        ticking = false;
        var max = track.scrollWidth - track.clientWidth;
        if (max <= 1) { bar.style.visibility = 'hidden'; return; }
        bar.style.visibility = '';
        var ratio = track.clientWidth / track.scrollWidth;
        var w = Math.max(0.18, Math.min(1, ratio));
        thumb.style.width = (w * 100) + '%';
        var p = track.scrollLeft / max;
        thumb.style.transform = 'translateX(' + (p * (1 - w) / w * 100) + '%)';
      }
      track.addEventListener('scroll', function () {
        if (!ticking) { ticking = true; requestAnimationFrame(update); }
      }, { passive: true });
      window.addEventListener('resize', update, { passive: true });
      update();
    });
  }

  /* Vídeos: solo se cargan y reproducen mientras están en pantalla */
  var vio = io ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting) {
        if (v.preload === 'none') v.preload = 'metadata';
        if (!reduce) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      } else if (!v.paused) {
        v.pause();
      }
    });
  }, { rootMargin: '120px 0px', threshold: 0.2 }) : null;

  function initVideos(root) {
    (root || document).querySelectorAll('video[data-v3-autoplay]').forEach(function (v) {
      if (v.__v3) return;
      v.__v3 = true;
      v.muted = true;
      v.setAttribute('muted', '');
      v.setAttribute('playsinline', '');
      if (vio) vio.observe(v); else { v.preload = 'metadata'; }
    });
  }

  /* Barra de «% vendido»: se llena al entrar en pantalla */
  function initStock(root) {
    (root || document).querySelectorAll('.v3-stock').forEach(function (s) {
      if (s.__v3) return;
      s.__v3 = true;
      var bar = s.querySelector('.v3-stock-bar i');
      var pct = parseInt(s.getAttribute('data-sold'), 10) || 0;
      if (!bar) return;
      function fill() { bar.style.width = pct + '%'; }
      if (!io || reduce) return fill();
      var o = new IntersectionObserver(function (en) {
        if (en[0].isIntersecting) { fill(); o.disconnect(); }
      }, { threshold: 0.4 });
      o.observe(s);
    });
  }

  /* Interruptor de tamaño → mueve el selector real del tema */
  function initSize(root) {
    (root || document).querySelectorAll('.v3-sz').forEach(function (sz) {
      if (sz.__v3) return;
      sz.__v3 = true;
      var info = sz.closest('product-info') || document.querySelector('product-info.main-product__info-container');
      if (!info) return;
      info.classList.add('v3-has-sz');
      var pos = sz.getAttribute('data-option');
      var btns = sz.querySelectorAll('.v3-sp');
      var label = sz.querySelector('[data-v3-sz-label]');
      var dim = sz.querySelector('[data-v3-sz-dim]');

      var idRe = new RegExp('-' + pos + '-\\d+$');
      function realInput(value) {
        var sel = info.querySelectorAll('variant-selects input[type="radio"]');
        for (var i = 0; i < sel.length; i++) {
          if (sel[i].value === value && idRe.test(sel[i].id)) return sel[i];
        }
        return null;
      }
      function paint(idx) {
        sz.setAttribute('data-size', idx);
        btns.forEach(function (b, i) { b.setAttribute('aria-checked', i === idx ? 'true' : 'false'); });
        var b = btns[idx];
        if (b && label) label.textContent = b.getAttribute('data-label');
        if (b && dim) dim.textContent = b.getAttribute('data-dim-short');
      }
      btns.forEach(function (b, i) {
        b.addEventListener('click', function () {
          paint(i);
          var inp = realInput(b.getAttribute('data-value'));
          if (inp && !inp.checked) inp.click();
          else if (!inp) {
            var s = info.querySelector('variant-selects select');
            if (s) {
              for (var k = 0; k < s.options.length; k++) if (s.options[k].value === b.getAttribute('data-value')) s.selectedIndex = k;
              s.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }
        });
        b.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
            e.preventDefault();
            var n = (i + (e.key === 'ArrowRight' ? 1 : -1) + btns.length) % btns.length;
            btns[n].focus(); btns[n].click();
          }
        });
      });
      info.addEventListener('change', function (e) {
        var t = e.target;
        if (!t || !t.closest || !t.closest('variant-selects')) return;
        btns.forEach(function (b, i) { if (b.getAttribute('data-value') === t.value) paint(i); });
      });
    });
  }

  /* Botones de las secciones → pulsan el botón real de compra (respeta el pack elegido) */
  function initCtas() {
    document.addEventListener('click', function (e) {
      var c = e.target.closest && e.target.closest('[data-v3-atc]');
      if (!c) return;
      e.preventDefault();
      var btn = document.querySelector('product-info.main-product__info-container .product-form__submit');
      var box = document.querySelector('product-info.main-product__info-container');
      if (c.getAttribute('data-v3-atc') === 'scroll' || !btn || btn.disabled) {
        if (box) box.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        return;
      }
      btn.click();
    });
  }

  /* Contador de la galería: cuenta solo las fotos visibles */
  function initGalleryCount() {
    document.querySelectorAll('[data-v3-gcount]').forEach(function (c) {
      if (c.__v3) return;
      var gal = c.closest('media-gallery');
      var list = gal && gal.querySelector('.product__media-list');
      if (!list) return;
      c.__v3 = true;
      function update() {
        var items = Array.prototype.filter.call(list.children, function (li) { return li.offsetWidth > 0; });
        if (!items.length) return;
        var base = list.getBoundingClientRect().left, best = 0, bestD = Infinity;
        items.forEach(function (li, i) {
          var d = Math.abs(li.getBoundingClientRect().left - base);
          if (d < bestD) { bestD = d; best = i; }
        });
        if (list.scrollLeft === 0 && bestD < 2 && best === 0) {
          var act = items.findIndex(function (li) { return li.classList.contains('is-active'); });
          if (act > 0) best = act;
        }
        c.textContent = (best + 1) + '/' + items.length;
      }
      var t = false;
      function later() { if (!t) { t = true; requestAnimationFrame(function () { t = false; update(); }); } }
      list.addEventListener('scroll', later, { passive: true });
      if ('MutationObserver' in window) new MutationObserver(later).observe(list, { subtree: true, attributes: true, attributeFilter: ['class', 'style'] });
      window.addEventListener('resize', update, { passive: true });
      update();
    });
  }

  function initAll(root) { initRails(root); initVideos(root); initStock(root); initSize(root); initGalleryCount(); }

  initCtas();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  window.drV3Init = initAll;
})();
